import Avatar from '../avatar'

const AvatarProfile = ({ title, list, className, src, avatar=true, width=36, height=36, ...props }) => {
    return (
        <>
            <div className={`flex items-center gap-3 ${className}`} {...props}>
                {
                    avatar ? (
                        <Avatar src={src} title={title} width={width} height={height} />
                    ) : null
                }
                {/* flex-shrink-0 */}
                <div className=''>
                    <div className="font-medium leading-5">{title}</div>
                    {list?.length ?
                        <div className="text-xs text-zinc-500 ">
                            {
                                list?.map((ele, idx) => (
                                    <span key={idx}>
                                        {ele}
                                        {idx < list.length - 1 && <span> • </span>}
                                    </span>
                                ))
                            }
                        </div>
                        :
                        null
                    }
                </div>
            </div>
        </>
    )
}

export default AvatarProfile
